export const LOAD_DICTIONARY = 'SET_DICTIONARY';

export const loadDictionary = (dictionary: any) => {
	return { type: LOAD_DICTIONARY, dictionary };
};
